import React, { useState, useMemo, useEffect } from "react";
import ReactTelInput from "react-telephone-input";
import config from "config/config.js";
import "assets/scss/react-telephone-input.css";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from "moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import dayOpenings, {
  dayOpeningsReservationData
} from "../../util/dayOpenings";
import dateFnsFormat from "date-fns/format";
import dateFnsParse from "date-fns/parse";
import Validator from "validatorjs";
import makeReservation from "api/reservation/make";
import { useForm, useField, splitFormProps } from "react-form";
import { useTranslation } from "react-i18next";

async function sendToFakeServer(values) {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return values;
}

function validateAddressStreet(value) {
  if (!value) {
    return "A street is required";
  }
  return false;
}

function fakeCheckValidName(value, type, t) {
  console.log(value, type);
  const rules = {};
  let error = "";
  switch (type.fieldName) {
    case "email": {
      rules.email = "required|email";
      error = t("reservation.error_message_email");
      break;
    }
    case "firstName": {
      rules.firstName = "required|min:3";
      error = t("reservation.error_message_name");
      break;
    }
    case "lastName": {
      rules.lastName = "required";
      error = t("reservation.error_message_last_name");
      break;
    }
    case "people": {
      rules.people = "required";
      break;
    }
    case "hour": {
      rules.hour = "required";
      error = t("reservation.error_message_time");

      break;
    }
    case "day": {
      rules.day = "required";
      break;
    }
    case "telephone": {
      rules.telephone = {
        prefix: "required",
        number: "required"
      };
      error = t("reservation.error_message_phone");
      break;
    }
  }
  console.log({ [`${type.fieldName}`]: value }, rules);
  let validation = new Validator({ [`${type.fieldName}`]: value }, rules);
  console.log("ssccscssc", validation.fails());
  if (validation.fails()) {
    return error;
  }
  return false;
}

// return instance.debounce(async () => {
//   console.log("checking name");
//   await new Promise(resolve => setTimeout(resolve, 1000));
//   // All names are valid, so return a false error
//   return false;
// }, 500);
// }

const InputField = React.forwardRef((props, ref) => {
  // Let's use splitFormProps to get form-specific props
  const [field, fieldOptions, rest] = splitFormProps(props);

  // Use the useField hook with a field and field options
  // to access field state
  const {
    value = props.type === "phone" ? { prefix: "+39", number: "" } : "",
    setValue,
    meta: { error, isTouched, isValidating },
    getInputProps
  } = useField(field, fieldOptions);

  const inputStyle = {};
  const { icon, type } = props;
  if (type === "phone") {
    inputStyle.maxWidth = "calc(100% - 150px)";
    inputStyle.lineHeight = "33px";
  }
  // Build the field
  // console.log(props.field, value, value.number);
  return (
    <div className="restaurant-detail-reservation-input-container">
      <i className={`${icon} reservation-input-icon`} />
      {type === "phone" ? (
        <div
          className="restaurant-detail-reservation-prefix"
          style={{ float: "left", maxWidth: "100px" }}
        >
          <ReactTelInput
            defaultCountry="it"
            initialValue={"+39"}
            onChange={e => {
              console.log(field);
              setValue(Object.assign({}, value, { prefix: e }));
              // if (this.state.fieldError) {
              //   this.setState({ prefix: e, fieldError: "" });
              // } else {
              //   this.setState({ prefix: e });
              // }
            }}
            autoFormat
            inputProps={{ readOnly: true, autoFocus: false }}
            onBlur={() => {}}
            flagsImagePath={`https://cdn.foodiestrip.com/ico/flags.png`}
            autoComplete="off"
          />
        </div>
      ) : null}
      <input
        // {...getInputProps({ ref, ...rest })}
        // initialValue={value.number ? value.number : value}
        defaultValue={
          value.number || value.number === "" ? value.number : value
        }
        onChange={e => {
          if (props.type === "phone") {
            setValue(Object.assign({}, value, { number: e.target.value }));
          } else {
            setValue(e.target.value);
          }
        }}
        placeholder={field}
        style={inputStyle}
        className="restaurant-detail-reservation-input"
      />{" "}
      {isTouched && error ? (
        <em style={{ marginLeft: !icon || type === "phone" ? "47px" : "27px" }}>
          {error}
        </em>
      ) : null}
    </div>
  );
});

function parseDate(str, format, locale) {
  const parsed = dateFnsParse(str, format, new Date(), { locale });
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale });
}

function DayChange(props) {
  const FORMAT = "dd/MM/yyyy";

  const [field, fieldOptions, { options, ...rest }] = splitFormProps(props);

  const {
    value = "",
    setValue,
    meta: { error, isTouched }
  } = useField(field, fieldOptions);

  const handleSelectChange = e => {
    console.log(dateFnsFormat(e, FORMAT));
    setValue(dateFnsFormat(e, FORMAT));
    props.setDay(dateFnsFormat(e, FORMAT));
  };

  return (
    <div
      className="restaurant-detail-reservation-input-container"
      // style={{ position: "relative", outline: "none" }}
    >
      <i className={"fa fa-calendar reservation-input-icon"} />
      <div
        className="restaurant-detail-reservation-calendar"
        style={{
          borderBottom: "none",
          padding: "10px",
          width: "calc(100% - 50px)",
          lineHeight: "1rem",
          fontStyle: "unset",
          fontWeight: "normal"
        }}
      >
        <DayPickerInput
          name="reservationDate"
          formatDate={formatDate}
          format={FORMAT}
          parseDate={parseDate}
          inputProps={{ className: "reservation-calendar-input" }}
          onDayChange={handleSelectChange}
          placeholder={`${dateFnsFormat(new Date(), FORMAT)}`}
          dayPickerProps={{
            disabledDays: [
              {
                before: new Date()
              }
              // {
              //   daysOfWeek: this.dayDisabled
              // }
            ],
            // modifiers: {
            //   thursdays: { daysOfWeek: [4] }
            // },
            modifiersStyles: {
              selected: {
                backgroundColor: "#e7382f"
              }
            }
          }}
        />
      </div>
      {isTouched && error ? <em>{error}</em> : null}
    </div>
  );
}

function SelectField(props) {
  const [field, fieldOptions, { options, ...rest }] = splitFormProps(props);

  const {
    value = "",
    setValue,
    meta: { error, isTouched }
  } = useField(field, fieldOptions);

  const handleSelectChange = e => {
    setValue(e.target.value);
  };

  return (
    <div
      className="restaurant-detail-reservation-input-container"
      style={{ position: "relative", outline: "none" }}
    >
      <i className={"icon icon-Ideal-for4-24 reservation-input-icon"} />
      <select
        {...rest}
        className="restaurant-detail-reservation-people-number"
        value={value}
        onChange={handleSelectChange}
      >
        <option disabled />
        {options.map(option => (
          <option
            key={option}
            className={`reservation-people-number`}
            value={option}
          >
            {option} {" persone"}
          </option>
        ))}
      </select>{" "}
      {isTouched && error ? (
        <em
          style={{
            width: "100%",
            display: "inline-block",
            marginLeft: "56px"
          }}
        >
          {error}
        </em>
      ) : null}
    </div>
  );
}

function HoursField(props) {
  const [field, fieldOptions, { options, ...rest }] = splitFormProps(props);
  const [hoursPage, setHoursPage] = React.useState(0);

  const hours = props.hours.slice(
    hoursPage * props.timesShown,
    hoursPage * props.timesShown + props.timesShown
  );
  const t = props.t;
  const {
    value = "",
    setValue,
    meta: { error, isTouched, isValidating }
  } = useField(field, fieldOptions);

  const handleSelectChange = e => {
    setValue(e.target.value);
  };

  return (
    <div>
      <div
        style={{
          width: "calc(100% - 20px)",
          padding: "0 10px",
          float: "left",
          marginBottom: "20px"
        }}
      >
        <i className="icon icon-time-24 choose-time-icon" />
        <div className="choose-icon-label">{t("reservation.choose_time")}</div>
        <div style={{ float: "right", display: "inline-block" }}>
          <button
            style={{ float: "left" }}
            className="reservation-pagination-button"
            disabled={hoursPage <= 0}
            onClick={() => {
              setHoursPage(hoursPage - 1);
              // this.setState({ hoursPage: this.state.hoursPage - 1 });
            }}
          >
            <i className="fa fa-chevron-left" />
          </button>
          <button
            style={{ float: "right", marginLeft: "10px" }}
            className="reservation-pagination-button"
            disabled={
              hoursPage >= Math.ceil(props.hours.length / props.timesShown) - 1
            }
            onClick={() => {
              setHoursPage(hoursPage + 1);

              // this.setState({ hoursPage: this.state.hoursPage + 1 });
            }}
          >
            <i className="fa fa-chevron-right" />
          </button>
        </div>
      </div>
      <div>
        {hours.map((el, index) => {
          let hour = el;
          if (el.hour) {
            hour = el.hour;
          }
          return (
            <div
              key={`${el}-${index.toString()}`}
              className={`hour-selectable ${
                value === hour ? "hour-selected" : ""
              }`}
              onClick={() => {
                setValue(hour);
                // if (this.state.time !== hour) {
                //   this.setState({
                //     time: hour,
                //     round: el.round,
                //     customText: el.customText
                //   });
                // if (el.customText && el.customText[this.props.defaultLanguage]) {
                //   alert(el.customText[this.props.defaultLanguage]);
                // }
                // }
              }}
            >
              {hour}
            </div>
          );
        })}
      </div>
      {isTouched && error ? (
        <em style={{ width: "100%", display: "inline-block" }}>{error}</em>
      ) : null}
    </div>
    // {isTouched && error ? <em>{error}</em> : null}
    // </div>
  );
}

export default function MyForm(props) {
  const [day, setDay] = useState(null);
  const [error, setError] = useState(null);

  const hours = useMemo(() => {
    if (props.reservation) {
      let date = moment();
      if (day) {
        date = moment(day, "DD/MM/YYYY");
      }
      console.log(
        "prapapappo",
        dayOpeningsReservationData(date, props.reservation.weekSystem),
        date.format("DD-MM")
      );

      return dayOpeningsReservationData(date, props.reservation.weekSystem);
    }
    return [];
  }, [props.reservation, day]);
  console.log("io sono quiii", props);
  // Use the useForm hook to create a form instance
  const { t, i18n } = useTranslation();
  const user = props.user && props.user.userDataId ? props.user.userDataId : {};
  const {
    Form,
    meta: { isSubmitted, isSubmitting, canSubmit }
  } = useForm({
    defaultValues: useMemo(
      () => ({
        telephone: {
          prefix: "+39",
          number: user.number || ""
        },
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        people: 3,
        day: dateFnsFormat(new Date(), "dd/MM/yyyy")
      }),
      []
    ),

    onSubmit: (values, instance) => {
      const rules = {
        firstName: "required|min:3",
        lastName: "required",
        email: "required|email",
        people: "required",
        hour: "required",
        day: "required"
      };

      let validation = new Validator(values, rules, {
        required: "You forgot to give a :attribute"
      });

      if (validation.passes()) {
        const objectToSend = {
          telephoneNumber: values.telephone.number,
          prefix: values.telephone.prefix,
          // round: this.state.round,
          number: values.people,
          day: values.day,
          hour: values.hour,
          firstName: values.firstName,
          lastName: values.lastName,
          restaurantId: props.restaurantId,
          language: props.defaultLanguage,
          email: values.email,
          reservationDate: new Date(
            `${moment(values.day, "DD/MM/YYYY").format("YYYY-MM-DD")}T${
              values.hour
            }:00Z`
          ),
          details: values.details
        };
        console.log(objectToSend);
        return makeReservation(objectToSend).then(e => {
          console.log(e);
          if (e && e.error && e.error.status) {
            switch (e.error.status) {
              case 601:
                setError(
                  `${t("reservation.error_api_reservation_601_1")}  ${t(
                    "reservation.error_api_reservation_601_2"
                  )}`
                );
                break;
              case 602:
                setError(
                  `${t("reservation.error_api_reservation_602")}  ${t(
                    "reservation.error_api_reservation_601_2"
                  )}`
                );
                break;
              case 603:
                setError(
                  `${t("reservation.error_api_reservation_603")}  ${t(
                    "reservation.error_api_reservation_601_2"
                  )}`
                );
                break;
              default:
                setError(
                  `${t("reservation.error_send_mail")} ${t(
                    "reservation.error_send_mail"
                  )}`
                );
                break;
            }
          }
        });
      }
    },
    debugForm: false
  });
  const restaurant = props.restaurant;
  if (isSubmitted && !error)
    return (
      <div>
        <em>
          <div
            // className="reservation-container"
            id="reservation-tab"
            style={{ width: "100%" }}
          >
            <div className="reservation-image-container">
              <img
                className="reservation-email-sent-image"
                alt="email-sent"
                title="email-sent"
                src={`https://cdn.foodiestrip.com/reservation/prenotazione.png`}
              />
            </div>
            <div className="reservation-thank-you-message">
              <span style={{ fontWeight: "bold", fontSize: "35px" }}>
                {t("reservation.sent_email_title")}
              </span>
              <br />
              <br />
              {t("reservation.sent_email_label_1")}{" "}
              <span style={{ fontWeight: "bold" }}>{restaurant.name}</span>{" "}
              {/* {t("reservation.sent_email_label_2")} */}
            </div>
            {/* <div className="reservation-time-left">{this.state.timeLeft}</div> */}
            {/* <div className="reservation-thank-you-message">
              {t("reservation.sent_email_extra_label")}
            </div> */}
            {/*
            <div className="reservation-countdown-message">
              <div>
                <i
                  className={
                    restaurant.service &&
                    restaurant.service.length > 0 &&
                    restaurant.service.some(el => el._id.type === "parking")
                      ? "icon icon-parking-24"
                      : "icon icon-Pin-24"
                  }
                  style={{ color: "#e7382f", fontSize: "25px" }}
                />
              </div>
               <div
                style={{ textAlign: "left", fontSize: "13px", width: "100%" }}
              >
                {restaurant.service &&
                restaurant.service.length > 0 &&
                restaurant.service.some(el => el._id.type === "parking") ? (
                  <div style={{ marginLeft: "15px" }}>
                    {this.getParkingDetails()}
                  </div>
                ) : (
                  <div>
                    {`${
                      restaurant.address.route ? restaurant.address.route : ""
                    } ${
                      restaurant.address.streetNumber
                        ? restaurant.address.streetNumber
                        : ""
                    }, ${
                      restaurant.address.postalCode
                        ? restaurant.address.postalCode
                        : ""
                    } ${
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ] &&
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ].admin3
                        ? restaurant[
                            `address${this.props.defaultLanguage.toUpperCase()}`
                          ].admin3.replace("Comune di", "")
                        : ""
                    } ${
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ] &&
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ].admin2
                        ? restaurant[
                            `address${this.props.defaultLanguage.toUpperCase()}`
                          ].admin2
                        : ""
                    } ${
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ] &&
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ].admin1
                        ? restaurant[
                            `address${this.props.defaultLanguage.toUpperCase()}`
                          ].admin1
                        : ""
                    } ${
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ] &&
                      restaurant[
                        `address${this.props.defaultLanguage.toUpperCase()}`
                      ].country
                        ? restaurant[
                            `address${this.props.defaultLanguage.toUpperCase()}`
                          ].country
                        : ""
                    }`}
                  </div>
                )}
              </div>
              <div
                className="show-more-results reverse-color"
                style={{ padding: "0 10px", marginLeft: "15px" }}
                onClick={() => {
                  this.sendStatistics();
                  const userPosition = `${this.props.positions[
                    this.props.positions.length - 1
                  ].lat.toString()},${this.props.positions[
                    this.props.positions.length - 1
                  ].lon.toString()}`;
                  const restaurantPosition = `${restaurant.location.coordinates[1].toString()},${restaurant.location.coordinates[0].toString()}`;
                  const url = `https://www.google.es/maps/dir/'${userPosition}'/'${restaurantPosition}'`;
                  window.open(url, "_blank");
                }}
              >
                {t("restaurantDetail.go").toUpperCase()}
              </div>
            </div>*/}
          </div>
        </em>
      </div>
    );
  return (
    <Form>
      <div style={{ marginBottom: "30px" }}>
        <div>
          <InputField
            field="email"
            icon={"fa fa-envelope"}
            type={"email"}
            validate={(value, el) => fakeCheckValidName(value, el, t)}
          />
        </div>
        <div>
          <InputField
            field="firstName"
            icon={"icon icon-Ideal-for6-24"}
            validate={(value, el) => fakeCheckValidName(value, el, t)}
          />
        </div>
        <div>
          <InputField
            field="lastName"
            validate={(value, el) => fakeCheckValidName(value, el, t)}
          />
        </div>
        {/* <div> */}
        <InputField
          field="telephone"
          type={"phone"}
          icon={"fa fa-phone-square"}
          validate={(value, el) => fakeCheckValidName(value, el, t)}
        />
        {/* </div> */}
        <div>
          <SelectField
            field="people"
            options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
            validate={(value, el) => fakeCheckValidName(value, el, t)}
          />
        </div>
        <div>
          <DayChange
            field="day"
            setDay={setDay}
            validate={(value, el) => fakeCheckValidName(value, el, t)}
          />
        </div>
        <div>
          <HoursField
            field="hour"
            timesShown={6}
            hours={hours}
            validate={(value, el) => fakeCheckValidName(value, el, t)}
            t={t}
          />
        </div>
        <div className="reservation-toc-container">
          {
            "Cliccando su “PRENOTA UN TAVOLO”, accetti i nostri Termini e Condizioni e confermi di aver letto le nostre Privacy Policy e Cookie Policy"
          }
        </div>
        <div className="reservation-button-container">
          <div style={{ display: "flex" }}>
            <button
              type="submit"
              className="reservation-button"
              disabled={!canSubmit}
            >
              Prenota
            </button>
          </div>
        </div>

        <div>
          <em>
            {isSubmitted && !error ? (
              <div className="reservation-thank-you-message">
                <span style={{ fontWeight: "bold", fontSize: "35px" }}>
                  {t("reservation.sent_email_title")}
                </span>
                {/* <br />
                <br />
                {t("reservation.sent_email_label_1")}{" "}
                <span style={{ fontWeight: "bold" }}>{restaurant.name}</span>{" "}
                {t("reservation.sent_email_label_2")} */}
              </div>
            ) : null}
          </em>
        </div>
        <div>
          <em>{error ? error : null}</em>
        </div>
      </div>
    </Form>
  );
}
